import { JsBridge } from '@ie-activity/oversea-act-js-lib'

// Get region and language
export const getLocal = () => {
  let locale;
  if (window.android) {
    // test environment = zh-CN;in
    locale = JsBridge.getLocale(); 
  } else {
    let region = '';
    region = (navigator.language.slice(3) || '').toUpperCase();
    locale = navigator.language + ';' + region;
  }
  return locale || 'en-IN;IN';
};

export const getRegion = () => {
  return getLocal().split(';')[1].toUpperCase();
};
export const getLang = () => {
  return getLocal().split(';')[0];
}
export function getQueryString(name, url) {
  let queryStr = url ? url.substring(url.indexOf('?')) : window.location.hash || window.location.search;
  let paramsStr = queryStr.substring(1);
  //If there are too many? Numbers to cause exceptions, replace them
  paramsStr = paramsStr.replace(/\?/g, '&');
  console.log(paramsStr)
  console.log(name)
  if (paramsStr) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = paramsStr.match(reg);
    console.log(r)
    if (r !== null) {
      return decodeURI(r[2].slice(0,2));
    }
    return null;
  }
  return null;
}

export function addUrlParameter(urlParameterArr, url) {
  Object.keys(urlParameterArr).map((item) => {
    url+= `&${item}=${urlParameterArr[item]}`
  })
  return url
}

/**
 * 解码apk传递数据
 * @param {*} base64Str
 */
 export const enhanceAtob = base64Str => decodeURIComponent(escape(atob(base64Str)))

export function ridUrlParam(url, aParam) {
  aParam.forEach((item) => {
    const fromindex = url.indexOf(`${item}=`); //必须加=号，避免参数值中包含item字符串
    if (fromindex !== -1) {
      // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
      const startIndex = url.indexOf('=', fromindex);
      const endIndex = url.indexOf('&', fromindex);
      const hashIndex = url.indexOf('#', fromindex);

      let reg;
      if (endIndex !== -1) {
        // 后面还有search参数的情况
        const num = endIndex - startIndex;
        reg = new RegExp(`${item}=.{${num}}`);
        url = url.replace(reg, '');
      } else if (hashIndex !== -1) {
        // 有hash参数的情况
        const num = hashIndex - startIndex - 1;
        reg = new RegExp(`&?${item}=.{${num}}`);
        url = url.replace(reg, '');
      } else {
        // search参数在最后或只有一个参数的情况
        reg = new RegExp(`&?${item}=.+`);
        url = url.replace(reg, '');
      }
    }
  });
  const noSearchParam = url.indexOf('=');
  if (noSearchParam === -1) {
    url = url.replace(/\?/, ''); // 如果已经没有参数，删除？号
  }
  return url;
}

export function isNight() {
  if (window.HeytapTheme && window.HeytapTheme.isNight) {
    return window.HeytapTheme.isNight()
  } else {
    return false
  }
}

export function  getColor(color,opacity) {
  // 16进制颜色值的正则
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 把颜色值变成小写
  var color = color.toLowerCase();

  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      var colorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // 处理六位的颜色值，转为rgba
    var colorChange = [];
    for (var i = 1; i < 7; i += 2) {
      colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
    }
    return "rgba(" + colorChange.join(",") + "," + opacity + ")";
  } else {
    return color;
  }
}

export default {
  getLocal,
  getRegion,
  getLang,
  getQueryString,
  addUrlParameter,
  ridUrlParam,
  isNight,
  enhanceAtob,
  getColor,
};



// WEBPACK FOOTER //
// ./src/utils/util.js